const loader = document.querySelector('script[data-pbn-collection-description]');
const readMoreLabel = loader?.dataset.readMore || 'Read more';
const readLessLabel = loader?.dataset.readLess || 'Read less';
const minimumCharacters = Number.parseInt(loader?.dataset.minimumCharacters || '200', 10);
const secondaryMinimumCharacters = Number.parseInt(
  loader?.dataset.secondaryMinimumCharacters || '160',
  10,
);
const descriptionSelector =
  'main[data-template="collection"] > [id$="__collection_description_bottom"] rte-formatter.rte';

let instanceCount = 0;

function enhanceDescription(description) {
  if (description.dataset.pbnCollectionDescriptionEnhanced === 'true') return;
  if (!description.textContent?.trim()) return;

  description.dataset.pbnCollectionDescriptionEnhanced = 'true';
  description.classList.add('pbn-collection-description');

  const sectionId = description.closest('.shopify-section')?.id;
  const idBase = sectionId?.replace(/[^a-zA-Z0-9_-]/g, '-') || `pbn-collection-${++instanceCount}`;
  description.id ||= `${idBase}-description`;

  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'pbn-collection-description__toggle';
  toggle.dataset.pbnCollectionDescriptionToggle = '';
  toggle.setAttribute('aria-controls', description.id);
  toggle.setAttribute('aria-expanded', 'false');
  toggle.textContent = readMoreLabel;
  toggle.hidden = true;
  description.insertAdjacentElement('afterend', toggle);

  let syncFrame;
  const syncCollapsedState = () => {
    cancelAnimationFrame(syncFrame);
    syncFrame = requestAnimationFrame(() => {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        toggle.hidden = false;
        return;
      }

      const normalizedTextLength = description.textContent.trim().replace(/\s+/g, ' ').length;
      const paragraphCount = description.querySelectorAll('p').length;
      const qualifiesAsLongCopy =
        normalizedTextLength >= minimumCharacters ||
        (paragraphCount >= 2 && normalizedTextLength >= secondaryMinimumCharacters);

      if (!qualifiesAsLongCopy) {
        description.classList.remove('is-collapsed');
        toggle.hidden = true;
        return;
      }

      description.classList.add('is-collapsed');
      const needsToggle = description.scrollHeight > description.clientHeight + 2;
      description.classList.toggle('is-collapsed', needsToggle);
      toggle.hidden = !needsToggle;
    });
  };

  toggle.addEventListener('click', () => {
    const willExpand = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', String(willExpand));
    toggle.textContent = willExpand ? readLessLabel : readMoreLabel;
    description.classList.toggle('is-collapsed', !willExpand);
  });

  const resizeObserver = new ResizeObserver(syncCollapsedState);
  resizeObserver.observe(description);
  syncCollapsedState();
}

function initializeCollectionDescription() {
  document.querySelectorAll(descriptionSelector).forEach(enhanceDescription);
}

initializeCollectionDescription();
document.addEventListener('shopify:section:load', initializeCollectionDescription);
